<template>
  <filtertron-tray-section
    v-if="category.createdAt"
    id="category-configurator-divisions"
    :title="lang.get('category.configuration.divisions.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <p>{{ lang.get('category.form.divisions.description') }}</p>

      <div class="form-group">
        <label>{{ lang.get('category.form.divisions.quantity.label') }}</label>
        <input
          type="text"
          :value="category.divisions"
          class="form-control"
          @input="e => handleInput('divisions', toInt(e.target.value))"
        />
      </div>
      <div class="checkbox styled">
        <input
          id="reassign-divisions"
          name="reassign"
          type="checkbox"
          :checked="category.reassign"
          @change="e => handleInput('reassign', e.target.checked)"
        />
        <label for="reassign-divisions">
          {{ lang.get('category.form.divisions.reassign.label') }}
          <help-icon
            :content="lang.get('category.form.divisions.reassign.helptext')"
          />
        </label>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import HelpIcon from '@/lib/components/Shared/HelpIcon';
import handleInputMixin from '../handle-input-mixin.js';
import toIntMixin from '../to-int-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    HelpIcon
  },
  mixins: [handleInputMixin, toIntMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  }
};
</script>
